// extracted by mini-css-extract-plugin
export default {"last_action_card_wrapper":"LastActionCard_last_action_card_wrapper__4pcM0","action":"LastActionCard_action__lQnpp","action_card":"LastActionCard_action_card__B0fuR"};